import {
  changePassword,
  getOperators,
  getUser,
  login,
  updateOperator,
  verifyMfa,
  enableMfa,
  verifyMfaEnable,
} from "./api-communication/RestApiCli";
import { uaeReinbursementAccounts } from "@components/login_page/RedirectLogin";
import { navigate } from "./navigationService";
import { updateScopeList } from "@utils/CommonUtil";
import { SecureTokenManager } from "./auth/secureTokenManager";

export function classifyAuthError(error) {
  const status = error?.response?.status;
  if (status === 401 || status === 403) {
    return "NotAuthorizedException";
  }
  if (status >= 500) {
    return "ServerError";
  }
  if (error?.response === undefined) {
    return "ConnectionError";
  }
  return "NotAuthorizedException";
}

export const authMethods = {
  signIn: async (username, password) => {
    try {
      const response = await login({
        identifier: username,
        password,
      });
      console.log("login response", response);
      if (response.data.mfaRequired) {
        return response;
      }
      const data = response["data"];
      const token = data["access_token"];
      const orgId = data["orgId"] ? data["orgId"] : "unassigned";
      const distId = data["distId"] ? data["distId"] : "unassigned";

      SecureTokenManager.storeTokens(token);
      localStorage.setItem("orgId", orgId);
      localStorage.setItem("distId", distId);
      localStorage.setItem("mfaEnabled", data["mfaEnabled"]);
      localStorage.setItem(
        "isUaeReinbursementAccount",
        String(
          uaeReinbursementAccounts.includes(distId) || uaeReinbursementAccounts.includes(orgId),
        ),
      );
      updateScopeList({ orgId });
      return { name: username, orgId: orgId };
    } catch (error) {
      console.error("login error", error);
      return { name: classifyAuthError(error) };
    }
  },

  verifyMfa: async (username, code) => {
    try {
      const response = await verifyMfa({
        username,
        token: code,
      });
      console.log("mfa:", response);
      const data = response["data"];
      const token = data["access_token"];
      const orgId = data["orgId"] ? data["orgId"] : "unassigned";

      SecureTokenManager.storeTokens(token);
      localStorage.setItem("orgId", orgId);
      localStorage.setItem("mfaEnabled", data["mfaEnabled"]);
      return { name: response.username, orgId: orgId };
    } catch (error) {
      console.error("login error", error);
      return { name: classifyAuthError(error) };
    }
  },

  changePassword: (oldPassword, newPassword) => {
    return changePassword({ oldPassword, newPassword });
  },

  enableMfa: async (successCallback, errorCallback) => {
    try {
      await enableMfa(successCallback, errorCallback);
    } catch (error) {
      return { name: "CannotEnbaleMfa" };
    }
  },

  verifyMfaEnable: async (token, successCallback, errorCallback) => {
    try {
      await verifyMfaEnable({ token: token }, successCallback, errorCallback);
    } catch (error) {
      return { name: "CannotVerifyMfaEnabled" };
    }
  },

  signOut: (path = "/") => {
    if (typeof window !== "undefined" && typeof window.chatbase === "function") {
      try {
        window.chatbase("resetUser");
      } catch (error) {
        console.error("Failed to reset Chatbase user", error);
      }
    }

    if (typeof window !== "undefined") {
      delete window.chatbaseUserConfig;
    }

    SecureTokenManager.clearTokens();
    localStorage.removeItem("orgId");
    localStorage.removeItem("mfaEnabled");
    navigate(path);
  },

  addUserToOrganization: (username, orgId, successCallback, errorCallback) => {
    updateOperator(
      { username: username, attributes: { family_name: orgId } },
      successCallback,
      errorCallback,
    );
  },
  giveUserARole: (username, role, successCallback, errorCallback) => {
    updateOperator(
      { username: username, attributes: { given_name: role } },
      successCallback,
      errorCallback,
    );
  },
  getCurrentUser: async (errorCallback?) => {
    let user = null;
    await getUser((response) => {
      console.log("getUser response", response);
      user = response.data;
    }, errorCallback);
    return user;
  },
  getCurrentUserName: async (errorCallback) => {
    try {
      const user = await authMethods.getCurrentUser();
      console.log(user);
      return user.username;
    } catch (error) {
      console.error(error);
      errorCallback();
    }
  },
  getCurrentUsersRole: async (errorCallback) => {
    try {
      const user = await authMethods.getCurrentUser();
      console.log("user", user);
      return user.role;
    } catch (error) {
      console.error(error);
      errorCallback();
    }
  },
  setCurrentUsersOrganizationId: async (errorCallback) => {
    try {
      const user = await authMethods.getCurrentUser();
      const orgId = user.orgId;
      localStorage.setItem("orgId", orgId);
    } catch (error) {
      console.error(error);
      errorCallback();
    }
  },
  getUsers: (orgId, successCallback, errorCallback) => {
    getOperators({ orgId: orgId }, successCallback, errorCallback);
  },
};

export function getOrganizationId() {
  return localStorage.getItem("orgId") ? localStorage.getItem("orgId") : "unassigned";
}

export function getDistId() {
  return localStorage.getItem("distId") ? localStorage.getItem("distId") : "unassigned";
}
